import styled from 'styled-components';
import { Button } from 'antd';

export const Container = styled.div`
  padding: 24px;
  background: #f5f5f5;
  min-height: calc(100vh - 64px);

  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #262626;
    margin: 0;
  }
`;

export const ActionButton = styled(Button)`
  border: none;
  box-shadow: none;
  padding: 4px 8px;
  height: auto;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;